export * from './accommodation-item';
